<template>
    <div class="app">
        <DefaultHeader @change-password="$bvModal.show('modal-change-password')" @logout="logout" />
        <div class="app-body">
            <AppSidebar fixed>
                <!-- <SidebarHeader/> -->
                <div v-if="isSearchSnAllowed" class="px-2 py-2">
                    <b-button block variant="info" @click="$bvModal.show('modal-pencarian-sn')">
                        Pencarian SN Unit
                    </b-button>
                </div>
                <SidebarForm/>
                <SidebarNav :navItems="nav"></SidebarNav>
            </AppSidebar>
            <main class="main">
                <CustomBreadcrumb :list="list"/>
                <div class="container-fluid">
                <router-view></router-view>
                </div>
            </main>
        </div>
        <DefaultFooter/>
        <b-modal id="modal-change-password" title="Ubah Password"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.input.focus()"
        >
            <b-form-group label="Password Lama">
                <b-form-input ref="input" type="password" v-model="input.oldPassword" />
            </b-form-group>
            <b-form-group label="Password Baru">
                <b-form-input type="password" v-model="input.newPassword" />
            </b-form-group>
            <b-form-group label="Ulangi Password Baru">
                <b-form-input type="password" v-model="input.confirmNewPassword" @keyup.enter="executeChangePassword" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeChangePassword">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-pencarian-sn" title="Pencarian SN Unit" centered no-close-on-backdrop no-close-on-esc hide-footer @shown="$refs.searchSn.focus()">
            <b-input-group>
                <b-form-input v-model="searchSn" ref="searchSn" placeholder="SN" maxlength="100" @keydown.enter="execSearchSn" />
                <b-input-group-append>
                    <b-button variant="primary" @click="execSearchSn">
                        <i class="fa fa-search mr-2" /> Cari
                    </b-button>
                </b-input-group-append>
            </b-input-group>
            <div class="mt-2">
                {{ searchResult }}
            </div>
        </b-modal>
    </div>
</template>

<script>
import nav from '@/_nav'
import { Sidebar as AppSidebar, SidebarForm, SidebarHeader, SidebarNav } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeader from './DefaultHeader'
import DefaultFooter from './DefaultFooter'
import CustomBreadcrumb from './CustomBreadcrumb'

export default {
    name: 'DefaultContainer',
    components: {
        AppSidebar,
        CustomBreadcrumb,
        DefaultHeaderDropdownAccnt,
        SidebarForm,
        SidebarHeader,
        SidebarNav,
        DefaultFooter,
        DefaultHeader
    },
    data () {
        return {

            nav: [],

            isSubmitting: false,

            input: {
                oldPassword: "",
                newPassword: "",
                confirmNewPassword: ""
            },

            searchSn: "",
            searchResult: ""

        }
    },
    computed: {

        isSearchSnAllowed() {
            return [0, 1, 2, 7, 8, 10].includes(this.$helper.getRoleId())
        },

        name () {
            return this.$route.name
        },

        list () {
            return this.$route.matched.filter((route) => (route.name || route.meta.label) && !route.meta.hideInBreadcrumb)
        }

    },
    methods: {

        executeChangePassword() {

            if(this.$helper.isBlank(this.input.oldPassword)) {
                return this.$helper.toastError(this, "Password lama tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.newPassword)) {
                return this.$helper.toastError(this, "Password baru tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.confirmNewPassword)) {
                return this.$helper.toastError(this, "Ulangi password baru tidak boleh kosong!")
            }

            if(this.input.newPassword != this.input.confirmNewPassword) {
                return this.$helper.toastError(this, "Password baru dan ulangi password baru tidak sama!")
            }

            let payload = new FormData()
            payload.append("oldPassword", this.input.oldPassword)
            payload.append("newPassword", this.input.newPassword)

            this.isSubmitting = true
            this.$axios.post("user/change-password", payload).then(res => {

                this.$bvModal.hide("modal-change-password")
                this.$helper.toastSuccess(this, "Password berhasil diubah!")

                this.input.oldPassword = ""
                this.input.newPassword = ""
                this.input.confirmNewPassword = ""

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        execSearchSn() {

            if(this.isSubmitting == true) { return }

            if(this.$helper.isBlank(this.searchSn)) {
                return this.$helper.toastError(this, "SN tidak boleh kosong!")
            }

            this.isSubmitting = true
            this.$axios.get("inventory/sn/?sn=" + this.searchSn).then(res => {
                this.searchResult = res.data
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        logout() {

            localStorage.removeItem("fullname")
            localStorage.removeItem("roleId")
            localStorage.removeItem("roleName")
            localStorage.removeItem("token")

            this.$router.push("/login")

        }

    },
    created() {

        // Auto-redirect to login page if token does not exist --> moved to router
        if(localStorage.getItem("token") == null) {
            this.$router.push({ path: "/login" })
        }

        // Consolidate navigation properties
        let navs = JSON.parse(JSON.stringify(nav.items))
        let roleId = Number(localStorage.getItem("roleId"))
        let newNav = []

        navs.forEach(item => {

            if(roleId == 0 || item.role.length == 0 || item.role.includes(roleId)) {

                if("children" in item) {

                    let allowedChild = []
                    item.children.forEach(child => {

                        if(roleId == 0 || child.role.length == 0 || child.role.includes(roleId)) {
                            allowedChild.push(child)
                        }

                    })

                    item.children = allowedChild

                }

                newNav.push(item)

            }

        })

        this.nav = newNav

    },
    mounted() {

        // Check versioning. Hard refresh if reload is required
        let reloadStatus = localStorage.getItem("reload")

        if(reloadStatus != null && reloadStatus == 1) {
            localStorage.removeItem("reload")
            window.location.reload(true)
        }

    }
}
</script>
